export default "__VITE_ASSET__V5TvVCBA__"